import * as Yup from "yup";

export const pickupSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  phone: Yup.string().required("Phone is required"),
  companyName: Yup.string().required("Company name is required"),
  vat: Yup.string().required("ABN/ACN/VAT/Tax ID is required"),
  country: Yup.string().required("Country is required"),
  state: Yup.string().required("State is required"),
  city: Yup.string().required("City is required"),
  postcode: Yup.string().required("Postcode is required"),
  addressLine1: Yup.string().required("Address is required"),
  locationType: Yup.string().required("Location type is required"),
  equipment: Yup.string().required("Equipment is required"),
  notes: Yup.string().required("Notes are required"),

  startDate: Yup.string().required("Start date is required"),
  endDate: Yup.string().required("End date is required"),
  timeSlot: Yup.string().required("Time slot is required"),

  registrationNo: Yup.string().required("Vehicle reg number is required"),
  driverName: Yup.string().required("Driver name is required"),
  driverPhone: Yup.string().required("Driver phone is required"),
  vehicleType: Yup.string().required("Vehicle type is required"),

  confirmationNumber: Yup.string().required("Confirmation number is required"),
  carrier: Yup.string().required("Carrier is required"),
  conNote: Yup.string().required("Consignment note is required"),
  
});

export const deliverySchema = pickupSchema;

export const transportDocumentsSchema = Yup.object().shape({
  deliveryNote: Yup.array().min(1, "Please upload Delivery Note"),
  packingList: Yup.array().min(1, "Please upload Packing List"),
  weightSlip: Yup.array().min(1, "Please upload Weight Slip"),
  invoice: Yup.array().min(1, "Please upload Invoice"),
  consignmentNote: Yup.array().min(1, "Please upload Consignment Note"),
  manifest: Yup.array().min(1, "Please upload Manifest"),
});

export const billingSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  phone: Yup.string().required("Phone is required"),
  email: Yup.string().email("Invalid email").required("Email is required"),
  companyName: Yup.string().required("Company name is required"),
  vat: Yup.string().required("ABN/ACN/VAT/Tax ID is required"),
  country: Yup.string().required("Country is required"),
  state: Yup.string().required("State is required"),
  city: Yup.string().required("City is required"),
  postcode: Yup.string().required("Postcode is required"),
  addressLine1: Yup.string().required("Address is required"),
});
